<script>
/**
 * Descripción: Pantalla Dashboard
 *
 * @displayName HomeViewComponent
 */

import { mapActions } from 'vuex';

const InstanceByUserFilterViewComponent = () =>
  import('@/views/InstanceByUser/InstanceByUserFilterViewComponent.vue');

export default {
  name: 'HomeViewComponent',

  components: {
    InstanceByUserFilterViewComponent
  },

  created() {
    this.addNavbar(['Panel De Control']);
  },

  methods: {
    ...mapActions('navbar', ['addNavbar'])
  }
};
</script>

<template>
  <div>
    <br />
    <h3>Panel de Control</h3>
    <v-divider></v-divider>
    <InstanceByUserFilterViewComponent />
  </div>
</template>
